import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout";
import ReportSettingsForm from "../../components/settings/ReportSettingsForm";
import { t } from "../../locales";
import { route } from "../../static/route";

const SettingsPage = () => {
  return (
    <Layout>
      <div className="px-6 py-6">
        {/* Breadcrumb */}
        <nav className="text-sm font-semibold text-gray-500 mb-2">
          <Link to={route.dashboard} className="text-brand-dark hover:underline">{t.settings.breadcrumbHome}</Link>
          <span className="mx-2">&rsaquo;</span>
          <span className="text-gray-500">{t.settings.pageTitle}</span>
        </nav>

        {/* Page title */}
        <h1 className="text-2xl font-bold text-brand-dark mb-6">{t.settings.pageTitle}</h1>

        {/* Form */}
        <ReportSettingsForm />
      </div>
    </Layout>
  );
};

export default SettingsPage;
